import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';

export interface ITabSettings {
  value: string;
  label: string;
  icon?: string;
}

@Component({
  selector: 'sgt-novo-tabs',
  templateUrl: './novo-tabs.component.html',
  styleUrls: ['./novo-tabs.component.scss'],
})
export class NovoTabsComponent implements AfterViewInit, OnChanges {
  @Input() tabs: ITabSettings[] = [];
  @Input() activeTab: string;
  @Output() activeTabChange = new EventEmitter<string>();

  @ViewChildren('tabButton') tabButtons: QueryList<ElementRef>;

  indicatorStyle: {
    [key: string]: string
  } = {};

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => this.updateIndicator());

    this.tabButtons.changes.subscribe(() => {
      this.updateIndicator();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeTab'] && !changes['activeTab'].firstChange) {
      setTimeout(() => this.updateIndicator());
    }
  }

  setActiveTab(tabValue: string): void {
    this.activeTab = tabValue;
    this.activeTabChange.emit(tabValue);
    this.updateIndicator();
  }

  updateIndicator(): void {
    const activeIndex = this.tabs.findIndex((t) => t.value === this.activeTab);
    const buttons = this.tabButtons?.toArray();

    if (buttons && buttons[activeIndex]) {
      const el = buttons[activeIndex].nativeElement as HTMLElement;
      this.indicatorStyle = {
        width: `${el.offsetWidth}px`,
        transform: `translateX(${el.offsetLeft}px)`,
      };
      this.cdr.detectChanges();
    }
  }
}
